var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group" },
    [
      _vm.title
        ? _c("label", { attrs: { for: _vm.id } }, [
            _c("strong", [_vm._v(_vm._s(_vm.title))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("app-dropdown", {
        attrs: {
          disabled: _vm.disabled,
          open: false,
          items: _vm.items,
          "default-item": _vm.defaultItem,
        },
        on: {
          change: function ($event) {
            _vm.value = $event
          },
        },
      }),
      _vm._v(" "),
      !_vm.validator(_vm.value) && _vm.errorMessage
        ? [
            _c("div", { staticClass: "invalid-feedback" }, [
              _vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    "),
            ]),
          ]
        : _vm.description
        ? [
            _c("small", { staticClass: "text-secondary form-text" }, [
              _vm._v("\n      " + _vm._s(_vm.description) + "\n    "),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }